export const trackHeapEvent = (eventName, details) => {
  if (window.heap && typeof window.heap.track === 'function') {
    window.heap.track(eventName, details);
  }
}
